/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import Loading from '../../components/loading/loading.component';
import PropTypes from 'prop-types';
import * as consts from '../../const';
import * as consentStatusConsts from '../../constants/consentStatus';
import { ControlLabel, Form, FormControl, FormGroup, Grid, Row } from 'react-bootstrap';
import { Button } from 'tc-client-common';
import Notification from '../common/notification/notification.component';
import { fromPairs } from 'ramda';

const FINAL_STATUSES_LABELS = {
  STUDY_COMPLETED: consentStatusConsts.PARTICIPANT_STATUS['STUDY_COMPLETED'],
  STUDY_TERMINATED: consentStatusConsts.PARTICIPANT_STATUS['STUDY_TERMINATED'],
  FAILED_SCREENING: consentStatusConsts.PARTICIPANT_STATUS['FAILED_SCREENING']
};

class ParticipantStatusModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: this.props.currentStatus,
      reason: null
    };
  }

  componentDidMount() {
    this.props.loadParticipantStatuses();
  }

  handleStatusChange = (event) => {
    this.setState({ status: event.target.value });
  };

  changeReasonHandler = (event) => {
    this.setState({ reason: event.target.value });
  };

  saveParticipantStatus = (e) => {
    if (!(this.state.status in FINAL_STATUSES_LABELS)) {
      let payload = {
        reason: this.state.reason
      };
      this.props.resetStatus(this.props.participantJourneyGid, this.props.studyGid, payload);
    } else {
      let payload = {
        participantJourneyGid: this.props.participantJourneyGid,
        status: this.state.status,
        reason: this.state.reason
      };
      this.props.saveStatus(payload, this.props.studyGid, this.props.participantId);
    }
    e.preventDefault();
    this.resetForm();
  };

  resetForm = () => {
    this.setState({
      status: '',
      reason: ''
    });
  };

  createParticipantStatusOptions = () => {
    let options = [];
    options.push(<option value="RESET_STATUS">{consts.ACTIVE_IN_STUDY}</option>);
    if (this.props.participantFinalStatuses) {
      let participantFinalStatuses = this.props.participantFinalStatuses.data.statuses;
      if (participantFinalStatuses) {
        for (let status of participantFinalStatuses) {
          options.push(<option value={status}>{FINAL_STATUSES_LABELS[status]}</option>);
        }
      }
    }
    return options;
  };

  render() {
    let body;
    if (this.props.isLoading) {
      body = <Loading />;
    } else {
      let errorBody = '';
      if (this.props.error) {
        errorBody = (
          <Row>
            <Notification type="error" data={this.props.error} />
          </Row>
        );
      }

      body = (
        <Form horizontal id="edit-participant-status-form" onSubmit={this.saveParticipantStatus}>
          <Grid id="edit-participant-status-grid" fluid>
            {errorBody}
            <Row>
              <FormGroup controlId="participantStatus">
                <ControlLabel>{consts.PARTICIPANT_STATUS}</ControlLabel>
                <FormControl
                  componentClass="select"
                  onChange={this.handleStatusChange}
                  required
                  value={this.state.status}
                >
                  {this.createParticipantStatusOptions()}
                </FormControl>
              </FormGroup>

              <FormGroup controlId="reason">
                <ControlLabel>
                  {consts.CHANGE_PARTICIPANT_STATUS_REASON} <span>*</span>
                </ControlLabel>
                <FormControl
                  componentClass="textarea"
                  id="reason"
                  value={this.state.reason}
                  onChange={this.changeReasonHandler}
                  required
                />
              </FormGroup>
            </Row>
          </Grid>
          <div className="edit-modal-footer">
            <hr className="edit-modal-divider" />
            <Button
              id="edit-participant-status-cancel-button"
              theme="default large-button"
              type="reset"
              handleClick={() => {
                this.props.hide();
                this.resetForm;
              }}
              label={consts.CANCEL_BTN}
            />
            <Button
              id="edit-participant-status-save-button"
              theme="active large-button"
              type="submit"
              label={consts.SAVE_BTN}
            />
          </div>
        </Form>
      );
    }
    return <div>{body}</div>;
  }
}

ParticipantStatusModal.propTypes = {
  error: PropTypes.object,
  participantFinalStatuses: PropTypes.object,
  isLoading: PropTypes.bool,
  currentStatus: PropTypes.string.isRequired,
  studyGid: PropTypes.string.isRequired,
  participantId: PropTypes.number.isRequired,
  participantJourneyGid: PropTypes.string.isRequired,
  loadParticipantStatuses: PropTypes.func,
  resetStatus: PropTypes.func,
  saveStatus: PropTypes.func,
  hide: PropTypes.func
};

export default ParticipantStatusModal;
